<!-- 编辑表格列 -->
<p-orderList [value]="keys" [dragdrop]="true" [metaKeySelection]="false" >
    <ng-template let-key pTemplate="item" >
        {{key['label']}}
        <a href="javascript:;" class="edit-font"  (click)="changeShowColumn($event,key)">{{key.show ? '隐藏':'显示'}}</a>
        |
        <a href="javascript:;" class="edit-font" (click)="changeFixColumn($event,key)">{{key.fix ? '取消固定':'固定'}}</a>
        <div style="z-index: 20;">
        </div>
    </ng-template>
</p-orderList>

<!-- <p-table [value]="keys" [reorderableColumns]="true" styleClass="p-datatable-sm" scrollHeight="flex">
    <ng-template pTemplate="header" let-columns>
        <tr>
            <th style="width:3rem"></th>
            <th pReorderableColumn>
                列名称
            </th>
            <th pReorderableColumn>
                操作
            </th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-res let-index="rowIndex">
        <tr [pReorderableRow]="index">
            <td>
                <span class="pi pi-bars" pReorderableRowHandle></span>
            </td>
            <td>
                {{res['label']}}
            </td>
            <td>
                <a href="javascript:;"  pRipple class="edit-font" (click)="changeShowColumn(res)">{{res.show ? '隐藏':'显示'}}</a>
                |
                <a href="javascript:;"  pRipple class="edit-font" (click)="changeFixColumn(res)">{{res.fix ? '取消固定':'固定'}}</a>
            </td>
        </tr>
    </ng-template>
</p-table> -->